import React, { useState } from "react";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
} from "@mui/material";
import { Icons } from "../../config/MuiIcons.config";

const AppAccordion = ({ title, children, defaultExpanded = false }) => {
  const [expanded, setExpanded] = useState(defaultExpanded);

  return (
    <Accordion
      expanded={expanded}
      onChange={() => setExpanded((p) => !p)}
      disableGutters
      square={false}
      sx={{
        borderRadius: "8px",
        boxShadow: "none",
        border: "1px solid rgba(0,0,0,0.09)",
        "&:before": { display: "none" },
        overflow: "hidden",
      }}
    >
      <AccordionSummary
        expandIcon={
          <Icons.ExpandMoreIcon
            sx={{
              transition: "transform 0.2s ease",
              color: "text.secondary",
            }}
          />
        }
        sx={{
          "& .MuiAccordionSummary-content": { my: 0 },
        }}
      >
        <Typography sx={{ fontWeight: 500, fontSize: "16px" }}>
          {title}
        </Typography>
      </AccordionSummary>
      <AccordionDetails>
        <Typography
          sx={{ fontWeight: 400, fontSize: "15px", color: "#4B5563" }}
        >
          {children}
        </Typography>
      </AccordionDetails>
    </Accordion>
  );
};

export default AppAccordion;
